// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Authentication_Auth__1dChK","Input":"Authentication_Input__2c-Cq"};